import * as React from 'react';
import DataTable from 'react-data-table-component';

const columns = [
  {
    selector: 'Date',
    name: 'Date',
    sortable: true,
  },
  {
    selector: 'Duration',
    name: 'Duration (mins)',
    sortable: true,
  },
  {
    selector: 'Total',
    name: 'Total Consumption (L)',
    sortable: true,
  },
];

const pagination = true
const paginationPage = 10
const paginationRowsPerPageOptions = [10]

const IrrigationTable = (rows) => {
  return (
    <div style={{ height: 350, width: '100%' }}>
      <DataTable
        columns={columns}
        data={rows.data}
        pagination={pagination}
        paginationPerPage={paginationPage}
        paginationRowsPerPageOptions={paginationRowsPerPageOptions}
      />
    </div>
  )
}

export default IrrigationTable